export const RangeIcon = () => {
    return (
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8h10" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
            <path d="M5 6v4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
            <path d="M11 6v4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
        </svg>
    );
};
